import type { FC } from 'react'
import { HBox } from '../layout/horizontal-box.js'
import { PulseProgress } from './pulse.js'
import type { PulseProps } from './pulse.js'
import styles from './pulse-box.module.css'

export interface PulseProgressBoxProps extends PulseProps {
  title?: string
}

export const PulseProgressBox: FC<PulseProgressBoxProps> = props => {
  const { title } = props
  return (
    <HBox className={styles.container}>
      <PulseProgress {...props} />
      {title ? <span className={styles.title}>{title}</span> : null}
    </HBox>
  )
}

export default PulseProgressBox
